import PropTypes from 'prop-types'
import classNames from 'classnames'

const Overlay = ({ isVisible, handleClick }) => {
  const overlayClass = classNames(
    'share-button-overlay',
    {
      active: isVisible
    }
  )

  return (
    <div
      className={overlayClass}
      onClick={handleClick}
    />
  )
}

Overlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
}

export default Overlay
